import { ItemBar } from "components/ItemBar";
import { ToastContext } from "context/ToastContext";
import { prepareCodesForSubmit, RangeTooLargeError } from "helpers/codeRanges";
import { Button } from "primereact/button";
import { useContext, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useCreateDiscountRulesetMutation } from "store/queries/procedureDiscountRuleset";

import {
  mapFormToRequestBody,
  getRulesetList,
} from "../helpers/mapFormToRequestBody";

export function Submit() {
  const {
    getValues,
    formState: { isValid },
  } = useFormContext();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [useCreateDiscountRuleset] = useCreateDiscountRulesetMutation();

  const { current: toastElement } = useContext(ToastContext);

  const createPayerRule = async () => {
    const values = getValues();
    let cptCodes: string[];
    try {
      cptCodes = prepareCodesForSubmit(values.cptCodes);
    } catch (err) {
      toastElement?.show({
        severity: "error",
        summary: "Range too large",
        detail:
          err instanceof RangeTooLargeError
            ? err.message
            : "Failed to expand code ranges",
      });
      return;
    }
    const rulesToCreateRaw = getRulesetList({ ...values, cptCodes });
    const rulesToCreate = rulesToCreateRaw.map((rule) => {
      // CLE-2524: creates declare applicability explicitly (wins over isDefault).
      return {
        ...mapFormToRequestBody(rule),
        applicability: rule.isDefault
          ? ("TYPICAL" as const)
          : ("SCOPED" as const),
      };
    });
    setLoading(true);
    try {
      const results = await Promise.all(
        rulesToCreate.map((rule) =>
          useCreateDiscountRuleset(rule)
            .unwrap()
            .catch(() => false)
        )
      );
      const allSuccessful = results.every((result) => result !== false);
      if (allSuccessful) {
        toastElement?.show({
          severity: "success",
          summary: "Payer Ruleset(s) created",
          detail: "Payer Ruleset(s) created successfully",
        });

        navigate("/payer-rules");
      } else {
        toastElement?.show({
          severity: "error",
          summary: "Error",
          detail:
            "An error has occurred attempting to create one or more discount rulesets",
        });
      }
    } catch (error) {
      toastElement?.show({
        severity: "error",
        summary: "Error",
        detail: "An error has occurred",
      });
    }
    setLoading(false);
  };
  return (
    <ItemBar>
      <div
        data-testid="submit__Hospital"
        className="flex flex-1 justify-content-end"
      >
        <Button
          label="Create Payer Rule"
          onClick={createPayerRule}
          disabled={!isValid}
          loading={loading}
        />
      </div>
    </ItemBar>
  );
}
